<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.returnBacks'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createdAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons> </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="receivesTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail
              v-if="row.order != null"
              :images="row.order.images"
            ></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="orderSerialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <span v-if="row.order == null">
              {{ row.orderSerialNo }}
            </span>
            <span v-else class="blue" @click="showRecord(row)">
              {{ row.orderSerialNo }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        />

        <vxe-table-column
          field="remark"
          :title="$t('returnBack.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <thumbnail-text
              v-if="row.voucher != null"
              :srcs="row.voucher"
              :text="'凭证'"
            />
            <div>
              <raw-html-limit-number
                :content="row.remark"
                :number="8"
                type="richText"
              />
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="haveGood"
          :title="$t('returnBack.haveGood')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span :class="row.haveGood == true ? 'green' : 'red'">
              {{ $t("boolean." + row.haveGood) }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('returnBack.receiveAt')" min-width="100">
          <template v-slot="{ row }">
            {{ row.receiverName }}
            <div class="font10">{{ row.receiveAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.ownerName }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- ======== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order :id="currentRowId" />
    </drawer>
  </div>
</template>

<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import ThumbnailText from "@/components/ThumbnailText";
import ReturnBack from "@/api/returnBack.js";
import ShowOrder from "@/views/oms/bargains/showOrder.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Thumbnail,
    RawHtmlLimitNumber,
    ThumbnailText,
    ShowOrder,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "returnBacks_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("returnBack.returnBackInfo"),
            items: [
              {
                label: this.$t("reworkInfos.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("reworkInfos.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        serialNo: null,
        profuctNo: null,
      },
      //
      currentRowId: null,
      show: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
  },
  methods: {
    showRecord(row) {
      this.currentRowId = row.order.id;
      this.show = true;
    },
    // 可选
    checCheckboxMethod({ row }) {
      return true;
    },
    //
    dataProvider(params) {
      return ReturnBack.search(params);
    },
  },
};
</script>
